export default "/fr/_next/static/assets/fonts/BlickVariable.0dc173c5cd98943290c991034b87b45e.woff2";